// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import Script from "next/script";
import * as MoEngage$PorterinFeature from "../fare-estimate-v1/utils/moengage/MoEngage.mjs";
import * as InitMoEngage$PorterinFeature from "../fare-estimate-v1/utils/moengage/InitMoEngage.mjs";
import * as AnalyticsHelper$PorterinFeature from "../../shared/core/helpers/AnalyticsHelper.mjs";

function MoEngageScripts(Props) {
  var router = Props.router;
  var isDesktop = Props.isDesktop;
  var configs = AnalyticsHelper$PorterinFeature.getMoEngageConfigByLocale(router.locale);
  if (configs === undefined) {
    return null;
  }
  var debugLogs = configs.mo_engage_debug_logs;
  var appId = configs.moengage_app_id;
  if (configs.moengage_enable_flag && InitMoEngage$PorterinFeature.isWhitelistedRoute(router, isDesktop)) {
    return React.createElement(React.Fragment, undefined, React.createElement(Script, {
                    strategy: "beforeInteractive",
                    children: MoEngage$PorterinFeature.getMoEngageScript(configs.mo_engage_data_cluster, debugLogs, appId)
                  }), React.createElement(Script, {
                    strategy: "beforeInteractive",
                    children: MoEngage$PorterinFeature.getMoEngageWebPushScript(configs.mo_engage_web_push_data_cluster, debugLogs, appId)
                  }));
  } else {
    return null;
  }
}

var make = MoEngageScripts;

export {
  make ,
}
/* react Not a pure module */
